import {
  Container,
  WorksCardList,
  Notification,
  Htag,
  HtagVariant,
  HtagAlign,
} from '../../components';
import WorksCard, { WorksCardProps } from '../../components/works-card';
import styles from './works.module.css';

export interface WorksProps extends Record<string, unknown> {
  works: WorksCardProps[];
}

export default function Works({ works, ...props }: WorksProps) {
  return (
    <div className={styles.section} {...props}>
      <Container>
        <Htag
          tag="h1"
          variant={HtagVariant.h2}
          align={HtagAlign.center}
          className={styles.title}
        >
          OUR WORKS
        </Htag>

        <WorksCardList>
          {works.map((work, index) => (
            <WorksCard key={index} {...work} />
          ))}
        </WorksCardList>

        <Notification
          title="HAVE A PROJECT IN MIND?"
          buttonName="Contact us"
          href="/contact"
          className={styles.notification}
        />
      </Container>
    </div>
  );
}
